<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        color="hrissecondary"
        class="white--text"
        :loading="progressing"
        v-on="on"
      >
        Generate Payroll Explanation
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Cycle Employee Documents"
      text="Generate payroll explanation for selected employees in this payroll cycle"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container
          class="full-height"
          fluid
        >
          <v-card>
            <v-row>
              <v-col cols="9">
                <v-data-table
                  v-model="selectedEmployees"
                  v-validate="'required'"
                  dense
                  :loading="tableLoading"
                  :headers="headers"
                  :items="filteredEmployees"
                  item-key="company_employee_uid"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-value="company_employee_uid"
                  show-select
                  class="elevation-1 mb-3"
                  height="272px"
                  :error-messages="errors.collect('selectedEmployees')"
                  data-vv-name="selectedEmployees"
                  data-vv-as="employee selection"
                >        
                  <template v-slot:top>
                    <v-row>
                      <v-toolbar
                        flat
                        color="white"
                      >
                        <v-toolbar-title>Employee Selection:</v-toolbar-title>
                      </v-toolbar>
                    </v-row>
                  </template>                       
                </v-data-table>
                
                <div :class="errors.first('selectedEmployees') ? 'py-0' : 'py-3'">
                  <span class="red--text text--lighten-1 caption">{{ errors.first('selectedEmployees') }}</span>
                </div>
              </v-col>
              
              <v-col cols="3">
                <v-text-field
                  v-model="searchInput"
                  placeholder="Filter employee by name"
                  append-icon="search"
                  label="Search Employee"
                  hide-no-data
                  hide-selected
                />

                <v-autocomplete
                  v-model="companiesFilter"
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Companies"
                  placeholder="Filter employee by company"
                  clearable
                  hide-selected
                  multiple
                  deletable-chips
                  chips
                />

                <v-card-actions style="position: absolute;bottom: 30px;right: 0px;">
                  <v-spacer />
                  <v-btn
                    :disabled="progressing"
                    text
                    @click="dialog = false"
                  >
                    Close
                  </v-btn>
                  <v-btn
                    :loading="progressing"
                    color="hrissecondary"
                    class="white--text px-10"
                    @click="submitForm"
                  >
                    Generate
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollCycleTransactionId: {
        type: Number,
        default: null,
      },
      payrollCycleEmployees: {
        type: Array,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        selectedEmployees: [], 
        companies: [],
        tableLoading: false,
        searchInput: '',
        companiesFilter: '',
        headers: [
          {
            text: 'Company',
            align: 'left',
            sortable: true,
            value: 'company_employee.company.name',
          },
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'company_employee.employee.person.name',
          },
          {
            text: 'Status',
            align: 'left',
            sortable: true,
            value: 'status',
          },
        ],
      }
    },
    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.payrollCycleEmployees.filter(function (payrollCycleEmployee) {
          return payrollCycleEmployee.company_employee.employee.person.name.toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })

        let filteredCompanies = this.customFilterCompanies(primaryFilterEmployees)

        return filteredCompanies
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        
        this.tableLoading = true
        this.companies = this.payrollCycleEmployees.map(payrollCycleEmployee => {
          return payrollCycleEmployee.company_employee.company
        })
        this.tableLoading = false
      },
      filteredEmployees (newList) {
        this.$validator.pause()
        
        const newCompEmpUids = new Set(newList.map(compEmp => compEmp.company_employee_uid))

        this.selectedEmployees = this.selectedEmployees.filter(selectedEmp =>
          newCompEmpUids.has(selectedEmp.company_employee_uid)
        )

        this.$nextTick(() => {
          this.$validator.resume()
        })
      },
    },
    methods: {
      customFilterCompanies (transactions) {
        if (this.companiesFilter.length === 0) return transactions

        return transactions.filter(transaction => {
          let companyUid = transaction.company_employee.company.id

          return _.intersection([companyUid], this.companiesFilter).length > 0
        })
      }, 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollCycleEmployees().generateExplanationReport(this.payrollCycleTransactionId, this.prepareFormData())
              .then(res => {
                this.$snack({ message: 'Payroll explanation report generated successfully' })
                this.selectedEmployees = []
                this.dialog = false
                this.$emit('updated')
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.message, 
                  })
                } else this.$snack({ color: 'error', message: err.response.data.message })
              })
              .finally(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          selectedCompanyEmployees: this.selectedEmployees.map(emp => emp.company_employee_uid),
        }
      },    
    },
  }
</script>
